import Content from './Content';

export default class SlidingContent extends Content {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
}
